import * as React from 'react';

import {EditionThumbnailCard} from 'shells/edition-thumbnail-list/edition-thumbnail-card';
import {GridList} from 'shells/grid-list/grid-list';
// @ts-expect-error - imported from .js/.jsx file
import {ArchiveIcon} from 'shells/icon/svg/archive-icon';
// @ts-expect-error - imported from .js/.jsx file
import {CloneIcon} from 'shells/icon/svg/clone-icon';
// @ts-expect-error - imported from .js/.jsx file
import {EyeIcon} from 'shells/icon/svg/eye-icon';

import type {TemplateStubFragment as Template} from 'nutshell-graphql-types';

import {appHistory} from '../../../history';

import {EmptyState} from './empty-state';

const CARD_WIDTH = 300;
const CARD_HEIGHT = 300;

type Props = {
    templates: Template[];
    onDeleteTemplate: (arg1: string) => Promise<any>;
    onRestoreTemplate: (arg1: string) => Promise<any>;
    isLoading: boolean;
    isFiltering: boolean;
    error: string | null | undefined;
    setDuplicatingTemplate: (arg1?: Template | null | undefined) => void;
    setIsAddingNewTemplate: (arg1: boolean) => void;
    hasFullAccessToCampaigns: boolean;
};

export function TemplatesList(props: Props) {
    return (
        <GridList
            isLoading={props.isLoading}
            itemWidth={CARD_WIDTH}
            loadingState={{itemHeight: CARD_HEIGHT, itemBackgroundColor: 'white'}}
            error={props.error}
            isFiltering={props.isFiltering}
            nothingFoundState={{title: 'No templates were found'}}
            emptyStateComponent={
                <EmptyState onPrimaryCtaClick={() => props.setIsAddingNewTemplate(true)} />
            }
        >
            {props.templates
                ? props.templates
                      .map((template) => {
                          const options = [
                              {
                                  label: 'View',
                                  handleSelect: () => {
                                      appHistory.push(template.edition.htmlUrlPath);
                                  },
                                  icon: <EyeIcon wrapWithDiv={false} size={18} />,
                              },
                          ];

                          const templateToDisplay =
                              template.edition &&
                              template.edition.comparison &&
                              template.edition.comparison.winnerEdition
                                  ? template.edition.comparison.winnerEdition
                                  : template.edition;

                          // @ts-expect-error
                          if (!templateToDisplay.deletedTime) {
                              options.push({
                                  label: 'Make a copy',
                                  handleSelect: () => {
                                      props.setDuplicatingTemplate(template);
                                  },
                                  icon: <CloneIcon size={16} />,
                              });
                              options.push({
                                  label: 'Archive',
                                  // @ts-expect-error
                                  variant: 'destructive',
                                  handleSelect: () => {
                                      props.onDeleteTemplate(template.id);
                                  },
                                  icon: <ArchiveIcon size={16} />,
                              });
                          }

                          // @ts-expect-error
                          if (templateToDisplay.deletedTime) {
                              options.push({
                                  label: 'Restore',
                                  handleSelect: () => {
                                      props.onRestoreTemplate(template.id);
                                  },
                                  icon: <ArchiveIcon size={16} />,
                              });
                          }

                          // @ts-expect-error
                          templateToDisplay.status = templateToDisplay.deletedTime
                              ? 'ARCHIVED'
                              : templateToDisplay.status;

                          return {
                              id: template.id,
                              createdTime: template.edition.createdTime,
                              status: templateToDisplay.status,
                              name: template.edition.name,
                              owner: props.hasFullAccessToCampaigns
                                  ? template.edition.campaign.owner
                                  : undefined,
                              thumbnailUrl:
                                  templateToDisplay &&
                                  templateToDisplay.emailTemplate &&
                                  templateToDisplay.emailTemplate.thumbnailUrl
                                      ? templateToDisplay.emailTemplate.thumbnailUrl
                                      : undefined,
                              options: options,
                              campaignType: 'TEMPLATE',
                              backgroundColor: template.edition.backgroundColor,
                          };
                      })
                      .map((template) => (
                          <EditionThumbnailCard
                              key={template.id}
                              edition={template}
                              onSelect={(templateId) => {
                                  const selectedTemplate = props.templates.find((templateItem) => {
                                      return templateItem.id === templateId;
                                  });

                                  if (selectedTemplate) {
                                      appHistory.push(selectedTemplate.edition.htmlUrlPath);
                                  }
                              }}
                          />
                      ))
                : null}
        </GridList>
    );
}
